import { is360ViewerDevice } from './utils'

function genTitleBox(sgtt) {
  const titleBox = document.querySelector('#titleBoxWidget')
  if (titleBox) {
    titleBox.remove()
  }

  if (sgtt) {
    const widgetContainer = document.querySelector('#widgetContainer')

    const titleBoxWidget = document.createElement('div')
    titleBoxWidget.className = 'titleBoxWidget collapsed'
    titleBoxWidget.id = 'titleBoxWidget'
    widgetContainer.appendChild(titleBoxWidget)

    const titleContent = document.createElement('div')
    titleContent.className = 'titleContent'
    titleContent.id = 'titleContent'
    titleBoxWidget.appendChild(titleContent)

    const titleContainer = document.createElement('div')
    titleContainer.className = 'titleContainer'
    titleContainer.id = 'titleContainer'
    titleContainer.innerHTML = sgtt.toString()
    titleContent.appendChild(titleContainer)

    const titleContentToggle = document.createElement('div')
    titleContentToggle.className = 'titleContentToggle ' + is360ViewerDevice()
    titleContentToggle.id = 'titleContentToggle'
    titleBoxWidget.appendChild(titleContentToggle)

    const imgTitleContentToggle = document.createElement('img')
    imgTitleContentToggle.className = 'imgTitleContentToggle'
    imgTitleContentToggle.id = 'imgTitleContentToggle'
    imgTitleContentToggle.src =
      'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzJweCIgaGVpZ2h0PSIzMnB4IiB2aWV3Qm94PSIwIDAgMzIgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+MV9pY29uL2xlZnQgYmxhY2sgNEAzeDwvdGl0bGU+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBkPSJNMTEuMTIxMzIwMyw1LjI5Mjg5MzIyIEwxOS42MDY2MDA3LDEzLjc3ODE3NDYgTDE5LjYwNjYwMTcsMTMuNzc4MTc0NiBMMjEuMDIwODE1MywxNS4xOTIzODgyIEMyMS40MTEzMzk2LDE1LjU4MjkxMjQgMjEuNDExMzM5NiwxNi4yMTYwNzc0IDIxLjAyMDgxNTMsMTYuNjA2NjAxNyBMMTEuMTIxMzIwMywyNi41MDYwOTY3IEMxMC43MzA3OTYxLDI2Ljg5NjYyMDkgMTAuMDk3NjMxMSwyNi44OTY2MjA5IDkuNzA3MTA2NzgsMjYuNTA2MDk2NyBMOC4yOTI4OTMyMiwyNS4wOTE4ODMxIEM3LjkwMjM2ODkzLDI0LjcwMTM1ODggNy45MDIzNjg5MywyNC4wNjgxOTM4IDguMjkyODkzMjIsMjMuNjc3NjY5NSBMMTYuMDcxLDE1Ljg5OSBMOC4yOTI4OTMyMiw4LjEyMTMyMDM0IEM3LjkwMjM2ODkzLDcuOTAyMzY4OTMgNy45MDIzNjg5Myw3LjA5NzYzMTA3IDguMjkyODkzMjIsNi43MDcxMDY3OCBMOS43MDcxMDY3OCw1LjI5Mjg5MzIyIEMxMC4wOTc2MzExLDQuOTAyMzY4OTMgMTAuNzMwNzk2MSw0LjkwMjM2ODkzIDExLjEyMTMyMDMsNS4yOTI4OTMyMiBaIiBpZD0icGF0aC0xIj48L3BhdGg+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iMV9pY29uL2xlZnQtYmxhY2stNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPG1hc2sgaWQ9Im1hc2stMiIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8dXNlIGlkPSJpY29uIiBmaWxsPSIjMDAwMDAwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNC42NTY4NTQsIDE1Ljg5OTQ5NSkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMTQuNjU2ODU0LCAtMTUuODk5NDk1KSAiIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgogICAgPC9nPgo8L3N2Zz4='
    titleContentToggle.appendChild(imgTitleContentToggle)

    titleContentToggle.addEventListener('click', e => {
      e.preventDefault()
      titleBoxWidget.classList.toggle('collapsed')
    })

    titleContentToggle.addEventListener(
      'touchstart',
      e => {
        e.preventDefault()
        titleBoxWidget.classList.toggle('collapsed')
      },
      { passive: false }
    )
  }
}

export default { genTitleBox }
